import { render, staticRenderFns } from "./ChecklistMenu.vue?vue&type=template&id=245c1145&"
import script from "./ChecklistMenu.vue?vue&type=script&lang=js&"
export * from "./ChecklistMenu.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistMenu.vue?vue&type=style&index=0&id=245c1145&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports